import { APP_PATHS } from 'setup/navigation/paths';

export function createInspectionChecklistItemRoute(
  projectId: string,
  inspectionId: string,
  checklistOrProtocolId: string
): string {
  return APP_PATHS.inspection.protocolItem(
    projectId,
    inspectionId,
    checklistOrProtocolId
  );
}

export function createInspectionRoute(
  projectId: string,
  inspectionId: string
): string {
  return APP_PATHS.inspection.single(projectId, inspectionId);
}

export function createInspectionGeneralNormRoute(
  projectId: string,
  inspectionId: string,
  templateId: string
): string {
  return APP_PATHS.inspection.templateInInspection(
    projectId,
    inspectionId,
    templateId
  );
}

export function createInspectionComplianceCheckRoute(
  projectId: string,
  inspectionId: string,
  protocolItemId: string
): string {
  return APP_PATHS.inspection.complianceCheck(
    projectId,
    inspectionId,
    protocolItemId
  );
}

export function createInspectionSectionRoute(
  projectId: string,
  inspectionId: string,
  sectionId: string
): string {
  return APP_PATHS.inspection.section(projectId, inspectionId, sectionId);
}

export function createInspectionTemplateSectionRoute(
  projectId: string,
  inspectionId: string,
  templateId: string,
  checklistSectionId: string
): string {
  return APP_PATHS.inspection.templateSection(
    projectId,
    inspectionId,
    templateId,
    checklistSectionId
  );
}

export function createInspectionTemplateViewSectionRoute(
  projectId: string,
  templateId: string,
  checklistSectionId: string
): string {
  return APP_PATHS.inspectionTemplate.section(
    projectId,
    templateId,
    checklistSectionId
  );
}

export function createComplianceCheckDocumentsBaseUrl(
  inspectionId: string,
  protocolItemId: string
): string {
  return inspectionId && protocolItemId
    ? `/inspection/${inspectionId}/protocolItem/${protocolItemId}/complianceCheck`
    : '';
}

export function createProtocolSectionDocumentsBaseUrl(
  inspectionId: string,
  sectionId: string
): string {
  return inspectionId && sectionId
    ? `/inspection/${inspectionId}/section/${sectionId}`
    : '';
}
